/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareMusic: {
  name: 'square-music';
  data: string;
} = {
  name: 'square-music',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h12A1.5 1.5 0 0 1 15.5 2v12a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2ZM2 1.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H2Zm5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM8.5 8a2.5 2.5 0 1 0 1 2V5.618a.5.5 0 0 1 .276-.447l1.448-.724a.5.5 0 1 0-.448-.894l-1.447.723A1.5 1.5 0 0 0 8.5 5.618V8Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
